import { get, isArray, map, noop } from 'lodash'
import React, { Fragment, useMemo } from 'react'
import styled from 'styled-components'

import Radio, { TOption } from '../Radio'
import RadioGroup, { TRadioGroup } from '../RadioGroup'

const Wrapper = styled.div``

export interface IRadioSelect extends TRadioGroup {
  value?: string
  spacing?: string
  onChange?: (val: any) => void
  disabled?: boolean
  fallbackOption?: string
  options?: TOption[] | Record<string, string>
}

const RadioSelect = (props: IRadioSelect): React.ReactElement => {
  const {
    value,
    spacing = '',
    onChange = noop,
    disabled = false,
    fallbackOption,
    ...rest
  } = props

  const clear = (): void => onChange(null)

  const options = useMemo<TOption[]>(() => {
    if (isArray(props.options)) {
      return props.options
    }
    return map(props.options, (v, k) => ({ value: k, label: v }))
  }, [props.options])

  return (
    <Wrapper style={{ marginTop: spacing || 0 }}>
      <RadioGroup {...rest}>
        {fallbackOption && (
          <Radio
            value={!value || value === ''}
            onChange={clear}
            option={{ label: fallbackOption, value: true }}
            disabled={disabled}
          />
        )}
        {map(options, (option) => (
          <Fragment key={option?.value}>
            <Radio
              key={get(option, 'value')}
              value={value}
              onChange={onChange}
              option={option}
              disabled={disabled || option.disabled}
            />
            {value === get(option, 'value') && get(option, 'description') && (
              <>{get(option, 'description')}</>
            )}
          </Fragment>
        ))}
      </RadioGroup>
    </Wrapper>
  )
}

export default RadioSelect
